module.exports = __webpack_public_path__ + "img/3.3624cd89.svg";